module.exports = __webpack_public_path__ + "img/CMMC.03091b7d.png";